import { type StoreParams } from '@/features/shared/utils/dataFetching/storeParams'

export const getSubstitutionPreferenceKey = (params: {
  storeParams: StoreParams
  productId: number
}) => ['Preference', params] as const
